import { render, staticRenderFns } from "./survey-step-weight.vue?vue&type=template&id=d1bb4d0e"
import script from "./survey-step-weight.vue?vue&type=script&lang=js"
export * from "./survey-step-weight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports